export default __webpack_public_path__ + "static/media/2.8f8cd710.jpg";